import { Component, inject, signal } from '@angular/core'
import { AgencyService } from '../../services/agency.service'
import { MatSelectModule } from '@angular/material/select'
import { AuthService } from '../../services/auth.service'
import { NgOptimizedImage } from '@angular/common'
import { HelpPopoverComponent } from './help-popover.component'
import { ActivatedRoute, Router } from '@angular/router'
import { toSignal } from '@angular/core/rxjs-interop'
import { FilterClearService } from '../../services/filter-clear.service'

@Component({
  selector: 'kh-header',
  imports: [MatSelectModule, NgOptimizedImage, HelpPopoverComponent],
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  agencyService = inject(AgencyService)
  authService = inject(AuthService)
  private router = inject(Router)
  private queryParams = toSignal(inject(ActivatedRoute).queryParams)
  private filterClearService = inject(FilterClearService)

  helpPopoverVisible = signal(false)
  helpPopoverPosition = signal<{ x: number; y: number } | null>(null)
  private helpPopoverTimeout: ReturnType<typeof setTimeout> | null = null

  onAgencyChange(event: Event) {
    const target = event.target as HTMLSelectElement
    this.agencyService.selectedAgencyID.set(target.value)
  }

  onHelpMouseEnter(event: MouseEvent) {
    if (this.helpPopoverTimeout) {
      clearTimeout(this.helpPopoverTimeout)
      this.helpPopoverTimeout = null
    }
    const target = event.currentTarget as HTMLElement
    const rect = target.getBoundingClientRect()
    this.helpPopoverPosition.set({
      x: rect.left,
      y: rect.bottom,
    })
    this.helpPopoverVisible.set(true)
  }

  onHelpMouseLeave() {
    this.helpPopoverTimeout = setTimeout(() => {
      this.helpPopoverVisible.set(false)
      this.helpPopoverPosition.set(null)
    }, 100)
  }

  onPopoverMouseEnter() {
    if (this.helpPopoverTimeout) {
      clearTimeout(this.helpPopoverTimeout)
      this.helpPopoverTimeout = null
    }
  }

  onPopoverMouseLeave() {
    this.helpPopoverVisible.set(false)
    this.helpPopoverPosition.set(null)
  }

  clearFilters() {
    const { tab } = this.queryParams() || {}

    this.filterClearService.clearFilters()

    this.router.navigate([], {
      queryParams: tab ? { tab } : {},
    })
  }
}
